/**
 * Some browsers that reach checkout have no `Object.hasOwn` (older engines,
 * and anti-detect browsers that report a newer Chrome than they run). The
 * payments partner's elements script calls it while it boots, so checkout
 * crashed there with "Object.hasOwn is not a function"
 * (Sentry POCKETSFLOW-FRONTEND-9P). This puts the standard fallback in place
 * before anything else runs.
 */

type HasOwn = (o: object, key: PropertyKey) => boolean;

export const installObjectHasOwn = (
	target: ObjectConstructor = Object,
): void => {
	if (typeof (target as { hasOwn?: unknown }).hasOwn === "function") return;
	const hasOwn: HasOwn = (o, key) => {
		if (o === null || o === undefined) {
			throw new TypeError("Cannot convert undefined or null to object");
		}
		// biome-ignore lint/suspicious/noPrototypeBuiltins: this is the fallback for a missing Object.hasOwn
		return Object.prototype.hasOwnProperty.call(Object(o), key);
	};
	Object.defineProperty(target, "hasOwn", {
		value: hasOwn,
		configurable: true,
		writable: true,
		enumerable: false,
	});
};

installObjectHasOwn();
